const ARROWS_CONTAINER_STYLE_TYPE = {
  NONE: 'NONE',
  SHADOW: 'SHADOW',
  BOX: 'BOX',
} as const;

export default ARROWS_CONTAINER_STYLE_TYPE;
